import React from 'react';
import Form from 'react-bootstrap/Form';

import SalesOrderController from '../../controller/SalesOrderController';
import Const from '../../util/Constants';

import FieldText from '../common/FieldText';
import FieldTextArea from '../common/FieldTextArea';
import FieldNumber from '../common/FieldNumber';
import FieldDecimal from '../common/FieldDecimal';
import FieldDate from '../common/FieldDate';
import FieldDateTime from '../common/FieldDateTime';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';
import FieldToggle from '../common/FieldToggle';
import FieldAddress from '../common/FieldAddress';

class SalesOrderAddEditCustom extends React.Component {

  getCustomFields = (sales, fields, onValueChange, inValid) => {
    const customField = SalesOrderController.getCustomFields(fields);
    let list = [];
    const keys = Object.keys(customField);
    for(let i = 0; i < keys.length; i++) {
      const type = customField[keys[i]].field_type;
      const key = keys[i];
      const field = customField[key];
      const value = sales[key];
      const innerData = { key: key, id: key, field: field, value: value,
        onValueChange: onValueChange, inValid: inValid };
      if(type === Const.Text) list.push(<FieldText {...innerData}/>);
      else if(type === Const.TextArea) list.push(<FieldTextArea {...innerData}/>);
      else if(type === Const.Number) list.push(<FieldNumber {...innerData}/>);
      else if(type === Const.Decimal) list.push(<FieldDecimal {...innerData}/>);
      else if(type.includes(Const.MultiSelect)) list.push(<FieldMultiSelect {...innerData}/>);
      else if(type.includes(Const.Select)) list.push(<FieldSelect { ...innerData } />);
      else if(type === Const.Date) list.push(<FieldDate { ...innerData } />);
      else if(type === Const.DateTime) list.push(<FieldDateTime { ...innerData } />);
      else if(type === Const.Toggle) list.push(<FieldToggle { ...innerData } />);
      else if(type === Const.Address) list.push(<FieldAddress { ...innerData } />);
    }
    return list;
  }
  
  render() {
    const sales = this.props.sales;
    const fields = this.props.model.fields;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;

    const list = this.getCustomFields(sales, fields, onValueChange, inValid);
    if(list.length === 0) return null;
    return <><div className="formhead col-md-12"><h2>Additional Information</h2></div><Form className="row row-cols-3 lead-form">{list}</Form></>;
  }
}

export default SalesOrderAddEditCustom;